import React, {createContext, Dispatch, ReactNode, SetStateAction, useEffect, useState} from 'react';
import {
    filtersData,
    filtersVisible
} from "../Storages";
import getInitialDataFilter from "../Components/PageFilters/initialDataFilter";
import { IFilter } from "../Components/PageFilters/types";

interface IProps {
    children: ReactNode
}

interface IProductProvider {
    filters: IFilter;
    setFilters: Dispatch<SetStateAction<IFilter>>;
    showFilters: boolean;
    setShowFilters: Dispatch<SetStateAction<boolean>>;
    loading: boolean;
    setLoading: Dispatch<SetStateAction<boolean>>;
}


const ProductContext = createContext<IProductProvider>({} as IProductProvider);

const ProductProvider: React.FC<IProps> = ({ children }) => {

    if(Object.keys(filtersData.get() || {}).length === 0) {
        filtersData.save(getInitialDataFilter());
    }

    if(Object.keys(filtersVisible.get() || {}).length === 0) {
        filtersVisible.save({visible: false});
    }

    const [filters, setFilters] = useState<IFilter>(filtersData.get());
    const [showFilters, setShowFilters] = useState<boolean>(filtersVisible.get()?.visible);
    const [loading, setLoading] = useState<boolean>(false);
    
    useEffect(() => {
        filtersData.save(filters);
    }, [filters])

    useEffect(() => {
        filtersVisible.save({visible: showFilters});
    }, [showFilters])


    const contextValue = {
        filters,
        setFilters,
        showFilters,
        setShowFilters,
        loading,
        setLoading
    };

    return (
        <ProductContext.Provider value={contextValue}>
            {children}
        </ProductContext.Provider>
    );
};

export {
    ProductContext,
    ProductProvider
}
